module.exports = __webpack_public_path__ + "img/2.1ec59da9.png";